var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-apps-banner",style:({
    'background-image': _vm.bannerLoaded ? `url(${_vm.bannerURL})` : 'none',
  })},[_c('div',{staticClass:"page-apps-banner__overlay"},[_c('h2',{staticClass:"page-apps-banner__heading",domProps:{"innerHTML":_vm._s(_vm.$t('apps.banner.title'))}})]),_vm._v(" "),(!_vm.bannerLoaded)?_c('t-skeleton-loader',{attrs:{"type":"rectangle","width":"100%","height":"100%","border-radius":"inherit"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }